
export const getNameFromServerText = serverText => serverText.split('target="_blank">').pop().split('</a>')[0];

export const addAttributeToUrls = (str, attribute) => str.replace(/(http)([.]{0,}[^"]{0,})/gm, `$&${attribute}`);

export const getFileURL = str => str.split('"').find(attr => attr.startsWith('http'));
